var _g, _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStep4WizSelected(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 73,
    viewBox: "0 0 74 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1147_1292)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37 65C55.2254 65 70 50.4493 70 32.5C70 14.5507 55.2254 0 37 0C18.7746 0 4 14.5507 4 32.5C4 50.4493 18.7746 65 37 65Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67 32.5C67 48.7494 53.6119 62 37 62C20.3881 62 7 48.7494 7 32.5C7 16.2506 20.3881 3 37 3C53.6119 3 67 16.2506 67 32.5Z",
    stroke: "url(#paint0_linear_1147_1292)",
    strokeWidth: 6
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.75 36.2969C26.4143 36.2969 26.0924 36.4302 25.8551 36.6676C25.6177 36.9049 25.4844 37.2268 25.4844 37.5625C25.4844 37.8982 25.6177 38.2201 25.8551 38.4574C26.0924 38.6948 26.4143 38.8281 26.75 38.8281H36.875C37.2107 38.8281 37.5326 38.6948 37.7699 38.4574C38.0073 38.2201 38.1406 37.8982 38.1406 37.5625C38.1406 37.2268 38.0073 36.9049 37.7699 36.6676C37.5326 36.4302 37.2107 36.2969 36.875 36.2969H26.75Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.0625 19C23.7198 19 22.4322 19.5334 21.4828 20.4828C20.5334 21.4322 20 22.7198 20 24.0625V40.9375C20 42.2802 20.5334 43.5678 21.4828 44.5172C22.4322 45.4666 23.7198 46 25.0625 46H48.6875C50.0302 46 51.3178 45.4666 52.2672 44.5172C53.2166 43.5678 53.75 42.2802 53.75 40.9375V24.0625C53.75 22.7198 53.2166 21.4322 52.2672 20.4828C51.3178 19.5334 50.0302 19 48.6875 19H25.0625ZM48.6875 21.5312H25.0625C24.3912 21.5312 23.7473 21.7979 23.2726 22.2726C22.7979 22.7473 22.5312 23.3912 22.5312 24.0625V26.1719H51.2188V24.0625C51.2188 23.3912 50.9521 22.7473 50.4774 22.2726C50.0027 21.7979 49.3588 21.5312 48.6875 21.5312ZM22.5312 40.9375V28.7031H51.2188V40.9375C51.2188 41.6088 50.9521 42.2527 50.4774 42.7274C50.0027 43.2021 49.3588 43.4688 48.6875 43.4688H25.0625C24.3912 43.4688 23.7473 43.2021 23.2726 42.7274C22.7979 42.2527 22.5312 41.6088 22.5312 40.9375Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1147_1292",
    x: 0,
    y: 0,
    width: 74,
    height: 73,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1147_1292"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1147_1292",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1147_1292",
    x1: 37,
    y1: 0,
    x2: 37,
    y2: 65,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DD4E22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0742F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep4WizSelected);
export default __webpack_public_path__ + "static/media/step4WizSelected.8c3cbc68996ca44a6ac29d637d0eb51f.svg";
export { ForwardRef as ReactComponent };